/*
 * Copyright (c) 2025
 * 
 * Created Date: Tuesday, September 2nd 2025, 08:11:42 pm
 * Author: Mochamad Sofyan
 * 
 */

import IconConfirmSuccess from "assets/icons/IconConfirmSuccess"
import { ButtonPrimary } from "components/Common/Buttons"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"

const SuccessAttendScanQRAlert = ({ name, agency, facilitator, date, time, onCloseButtonClicked = () => { } }) => {
    const { t } = useTranslation();
    
    return <div className="luna-alert-content-container success-attend-scan-qr">
        <div className="icon-success">
            <IconConfirmSuccess width={64} height={64} />
        </div>
        <h5 className="themetext-blue">{t("modalAttendScanQr.successScan")}</h5>
        <div className="description">
            <p>{t("modalAttendScanQr.class")} : {name}</p>
            <p>{t("modalAttendScanQr.date")} : {date}</p>
            <p>{t("modalAttendScanQr.time")} : {time}</p>
            <p>{t("modalAttendScanQr.agency")} : {agency}</p>
            <p>{t("modalAttendScanQr.facilitator")} : {facilitator}</p>
        </div>
        <div className="luna-alert-footer">
            <ButtonPrimary containerClass="btn-close-dialog" onClick={() => {
                onCloseButtonClicked();
                Swal.close()
            }}>{t('common.close')}</ButtonPrimary>
        </div>
    </div>
}

export default SuccessAttendScanQRAlert
